import { Deserializable } from '../../../lib/models/deserializable';

export class MortgageClubDto implements Deserializable {
  public Code: string;
  public Number: string;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
